import React, { useRef, useEffect, useState } from 'react'
import Chart from 'chart.js'
import getMaterialColor from './MaterialColorCoding'

const DoughnutGraph = ({ labels, data }) => {
  const chartRef = useRef(null)
  const [legend, setLegend] = useState([])

  useEffect(() => {
    const currentChart = new Chart(chartRef.current, {
      type: 'doughnut',
      data: {
        labels: labels,
        datasets: [
          {
            data: data,
            backgroundColor: labels.map(label => getMaterialColor(label))
          }
        ]
      },
      options: {
        legendCallback: function(chart) {
          const legend = []
          chart.data.labels.forEach((label, i) => {
            legend.push(
              <span key={chart.id + '.' + i} style={{ fontSize: '14px' }}>
                <div
                  className="dashboard-doughnut-legendSquare"
                  style={{ backgroundColor: chart.data.datasets[0].backgroundColor[i] }}
                />
                {label}
              </span>
            )
          })
          return (
            <div key={chart.id} className="dashboard-doughnut-legend">
              {legend}
            </div>
          )
        },
        legend: false,
        aspectRatio: 1,
        layout: {
          padding: 20
        }
      }
    })
    setLegend([currentChart.generateLegend()])
    // eslint-disable-next-line
  }, [data])

  return (
    <div>
      <canvas ref={chartRef} />
      {legend}
    </div>
  )
}

export default DoughnutGraph
